<template>
  <div>
    <h5
      role="button"
      @click="isCollapsed = !isCollapsed"
      class="user-select-none"
      :aria-expanded="isCollapsed ? 'true' : 'false'"
      aria-controls="collapse"
    >
      <ChevronRight v-if="!isCollapsed" :size="16" aria-hidden="true" />
      <ChevronDown v-else :size="16" aria-hidden="true" />
      {{ header }}
    </h5>
    <hr class="w-75 ml-0" />
    <b-collapse id="collapse" :class="isCollapsed ? null : 'collapsed'" v-model="isCollapsed">
      <b-list-group horizontal class="bv-example-row" v-for="item in data" :key="'reisetermin' + item.label">
        <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut" style="">
          <h6 class="my-1 leftLabel">{{ item.label }}</h6>
        </b-list-group-item>
        <b-list-group-item
          class="col-6 d-flex align-items-center"
          :class="'detailLabelGreyedOut'"
          :variant="item.variant"
        >
          <span v-if="item.renderer !== null">
            <span v-if="item.renderer === 'paxWidget'">
              <PaxWidget
                :paxObject="item.value.pax"
                :minPax="item.value.minPax"
                :maxPax="item.value.maxPax"
                :kalkPax="item.value.kalkPax"
                :forecastPax="item.value.forecastPax"
                :durchfuehrbareMinPax="item.value.durchfuehrbareMinPax"
              ></PaxWidget>
            </span>
            <span v-else v-html="item.renderer"></span>
          </span>

          <h6 v-else class="w-100 mb-0 leftLabel" :contenteditable="item.editable">
            {{ item.value }}
            <template v-if="item?.append" class="ml-1">{{ item.append }}</template>
          </h6>
        </b-list-group-item>
      </b-list-group>
    </b-collapse>
  </div>
</template>
<script>
import { ChevronDown, ChevronRight } from 'lucide-vue';
import PaxWidget from '@/components/produkte/reisetermine/pax-widget.vue';

export default {
  props: {
    isCollapsedOnMount: { type: Boolean, default: false },
    data: { type: Array, required: true },
    header: { type: String, requred: true },
  },
  components: { PaxWidget, ChevronDown, ChevronRight },
  data() {
    return {
      isCollapsed: false,
    };
  },
  mounted() {
    this.isCollapsed = this.isCollapsedOnMount;
  },
  methods: {},
};
</script>
<style scoped>
.normalFormatted {
  border-style: solid;
  border-color: rgba(114, 114, 114, 0.15);
}
.detailLabelGreyedOut {
  background-color: rgba(114, 114, 114, 0.05);
  border-style: solid;
  border-color: rgba(114, 114, 114, 0.15);
}
.leftLabel {
  font-size: 1.05rem;
  font-weight: 500;
}
.list-group {
  height: 42px;
}
</style>
